<app-loader></app-loader>
<!-- Patient Header Section -->
<div class="ipd-patient-header">
    <!-- Left Section: Back button, Avatar, Patient Info -->
    <div class="patient-header-left">
        <i-tabler name="arrow-left" class="icon-20 cursor-pointer" (click)="goBack()"></i-tabler>
        <div class="patient-avatar-container">
            <img class="patient-avatar" [src]="profileImagePathSrc" alt="Patient avatar"
                fallbackImage="assets/images/profile/user-1.jpg" />
        </div>

        <div class="patient-info-block">
            <h4 class="patient-name m-0" *ngIf="OpdData" (click)="viewPatientDetails(patientinfo)">{{ OpdData.patientName }} ({{OpdData.patientNumber}})</h4>
            <div class="patient-meta" *ngIf="patientinfo">
                <span class="patient-age">{{patientinfo.age}}</span>
                <span class="patient-gender-badge" [ngClass]="patientinfo.gender === 'M' ? 'male' : 'female'">
                    {{getGenderName(patientinfo.gender)}}
                </span>
            </div>
        </div>
    </div>

    <!-- Right Section: OPD Details -->
    <div class="patient-header-right">
        <div class="opd-info-item" *ngIf="OpdData">
            <span class="opd-label">{{ 'LABEL.OPD_NO' | translate }}</span>
            <span class="opd-value opd-link" (click)="viewOPD(OpdData)">{{ OpdData.opdNumber }}</span>
        </div>
        <div class="opd-info-item" *ngIf="OpdData">
            <span class="opd-label">{{ 'LABEL.OPD_DATE' | translate }}</span>
            <span class="opd-value">{{ OpdData.opdDate | date: 'dd-MM-yyyy' }}</span>
        </div>
        <div class="opd-info-item" *ngIf="doctorDetails">
            <span class="opd-label">{{ 'LABEL.DOCTOR' | translate }}</span>
            <span class="doctor-value">Dr. {{doctorDetails.firstName}}
                {{doctorDetails.lastName}}</span>
        </div>
    </div>
</div>

<!-- Action Buttons -->
<div class="ipd-action-buttons m-b-10">
    <button mat-flat-button color="primary" class="action-btn filled"
        (click)="printAdmissionPaper()">{{'BUTTON.BTN_ADMISSION_PAPER' |translate}}</button>
    <button mat-flat-button color="primary" class="action-btn filled" (click)="openOperationSummary()">{{
        'BUTTON.BTN_OPERATION_SUMMARY'|translate}}</button>
    <button mat-flat-button color="primary" class="action-btn filled" (click)="openPrescription()">{{
        'ENTITY.PRESCRIPTION'|translate}}</button>
    <button mat-flat-button color="primary" class="action-btn filled" (click)="openDischargeCard()">{{
        'BUTTON.BTN_DISCHARGE_CARD' | translate}}</button>
    <ng-container *ngIf="ipdData">
        <button mat-flat-button color="primary" class="action-btn filled" (click)="openMedicalCertificate()"
            *ngIf="ipdData.dischargeTime && ipdData.dischargeDate">{{
            'BUTTON.BTN_MEDICAL_CERTIFICATE' | translate}}</button>
    </ng-container>
    <button mat-stroked-button color="primary" class="action-btn" (click)="openBillDialog()"
        [disabled]="ipdData && !canGenerateBill(ipdData)">
        {{ 'ENTITY.BILL' | translate }}
    </button>
</div>

<mat-card class="cardWithShadow">
    <mat-card class="table-container m-0">
        <mat-card-content class="p-0">
            <div class="category-scroll">
                <h3>{{ 'LABEL.IPD_DETAILS' | translate}}</h3>
                <mat-divider class="m-t-10"></mat-divider>

                <!-- ROW 1 -->
                <div class="row" *ngIf="ipdData">
                    <div class="col-lg-6">
                        <div class="patient-details">
                            <div class="detail-item">
                                <label>{{ 'LABEL.IPD_NO' | translate}}:</label>
                                <span>{{ ipdData.ipdNumber }}</span>
                            </div>
                            <div class="detail-item">
                                <label>{{ 'LABEL.IPD_DATETIME' | translate}}:</label>
                                <span>{{ ipdData.ipdDate | date:'dd-MM-yyyy' }} / {{ ipdData.ipdTime|timeFormat
                                    }}</span>
                            </div>
                            <div class="detail-item">
                                <label>{{ 'LABEL.PROVISIONAL_DIAGNOSIS' | translate}}:</label>
                                <span>{{ ipdData.provisionalDiagnosis }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="patient-details">
                            <div class="detail-item" *ngIf="ipdData.wardName">
                                <label>{{ 'ENTITY.WARD' | translate}}:</label>
                                <span>{{ ipdData.wardName }}</span>
                            </div>
                            <div class="detail-item" *ngIf="ipdData.roomTypeName">
                                <label>{{ 'LABEL.ROOM_TYPE_NO' | translate}}:</label>
                                <span>{{ ipdData.roomTypeName }} / {{ ipdData.roomNo }}</span>
                            </div>
                            <div class="detail-item" *ngIf="ipdData.bedNo">
                                <label>{{ 'LABEL.BED_NUMBER' | translate}}:</label>
                                <span>{{ ipdData.bedNo }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Operation Summary Section -->
                <div class="ipd-header m-t-20" *ngIf="operationSummary">
                    <h3 class="ipd-title">{{ 'BUTTON.BTN_OPERATION_SUMMARY' | translate}}</h3>
                </div>
                <mat-divider class="m-t-10" *ngIf="operationSummary"></mat-divider>

                <div class="row" *ngIf="operationSummary">
                    <div class="col-lg-12">
                        <div class="patient-details">
                            <div class="detail-item" *ngIf="operationSummary.assistantDoctorName">
                                <label>{{ 'LABEL.ASSITANT_DOCTOR' | translate}}:</label>
                                <span>{{ operationSummary.assistantDoctorName }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="operationSummary">
                    <div class="col-lg-12">
                        <div class="patient-details">
                            <div class="detail-item" *ngIf="operationSummary.anesthetistName">
                                <label>{{ 'LABEL.ANESTHETIST' | translate}}:</label>
                                <span>{{ operationSummary.anesthetistName }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="operationSummary">
                    <div class="col-lg-12">
                        <div class="patient-details">
                            <div class="detail-item" *ngIf="operationSummary.natureOfTreatmentName">
                                <label>{{ 'LABEL.NATURE_OF_TREATMENT' | translate}}:</label>
                                <span>{{ operationSummary.natureOfTreatmentName }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="operationSummary">
                    <div class="col-lg-12">
                        <div class="patient-details">

                            <div class="detail-item" *ngIf="operationSummary.treatmentGiven">
                                <label>{{ 'LABEL.TREATMENT_GIVEN' | translate}}:</label>
                                <span>{{ operationSummary.treatmentGiven }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Discharge Card Section -->
                <ng-container *ngIf="ipdData">
                    <div class="ipd-header m-t-20" *ngIf="ipdData.dischargeTime && ipdData.dischargeDate">
                        <h3 class="ipd-title">{{ 'BUTTON.BTN_DISCHARGE_CARD' | translate }}</h3>
                    </div>

                    <mat-divider class="m-t-10" *ngIf="ipdData.dischargeTime && ipdData.dischargeDate">
                    </mat-divider>
                </ng-container>
                <div class="row" *ngIf="ipdData">
                    <div class="col-lg-12">
                        <div class="patient-details">
                            <div class="detail-item" *ngIf="ipdData.dischargeDate && ipdData.dischargeTime">
                                <label>{{ 'LABEL.DISCHARGE_DATETIME' | translate}}:</label>
                                <span>{{ ipdData.dischargeDate | date: 'dd-MM-yyyy' }} / {{
                                    ipdData.dischargeTime|timeFormat }}</span>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="row" *ngIf="ipdData">
                    <div class="col-lg-12">
                        <div class="patient-details">
                            <div class="detail-item" *ngIf="ipdData.finalDiagnosis">
                                <label>{{ 'LABEL.FINAL_DIAGNOSIS' | translate}}:</label>
                                <span>{{ ipdData.finalDiagnosis }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="ipdData">
                    <div class="col-lg-12">
                        <div class="patient-details">
                            <div class="detail-item" *ngIf="ipdData.treatmentAdvice">
                                <label>{{ 'LABEL.TREATMENT_ADVICE' | translate}}:</label>
                                <span>{{ ipdData.treatmentAdvice }}</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </mat-card-content>
    </mat-card>

</mat-card>